import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openPortal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newTabIconDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	textIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'issue-create.modal.create-form.proforma-banner.title',
		defaultMessage: 'This request type includes a form that can’t be seen in this view',
		description:
			'Title displayed within GIC proforma banner informing a user to use portal for raising a request with all fields available.',
	},
	text: {
		id: 'issue-create.modal.create-form.proforma-banner.text',
		defaultMessage:
			'Create an issue using all fields on this request type and its form in the portal.',
		description:
			'Text displayed within GIC proforma banner informing a user to use portal for raising a request with all fields available.',
	},
	openPortal: {
		id: 'issue-create.modal.create-form.proforma-banner.open-portal',
		defaultMessage: 'Open portal',
		description:
			'Link to open the portal from within GIC proforma banner informing a user to use portal for raising a request with all fields available.',
	},
	newTabIconDescription: {
		id: 'issue-create.modal.create-form.proforma-banner.new-tab-icon-description',
		defaultMessage: 'This link will be opened in a new tab',
		description:
			'Accessibility text to let screen reader user know that the link will be opened in a new tab',
	},
	textIssueTermRefresh: {
		id: 'issue-create.modal.create-form.proforma-banner.text-issue-term-refresh',
		defaultMessage:
			'Create a work item using all fields on this request type and its form in the portal.',
		description:
			'Text displayed within GIC proforma banner informing a user to use portal for raising a request with all fields available.',
	},
});
export default messages;
